<template>
    <DPHeader titlu="Despre site"/>
    <div class="container">
        <p>
            Site realizat pentru gestionarea activităților extrașcola din cadrul Colegiul Național "Liviu Rebreanu" Bistrița.
        </p>
        <p>
            Autor: Silviu Candale.
        </p>
  </div>
</template>

<script>
import DPHeader from './DPHeader.vue'

export default {
  name: 'DespreProiect',
  components: {
    DPHeader
  }
}
</script>

<style lang="scss" scoped>

</style>
